export default __webpack_public_path__ + "static/media/carregar.aeff492a.gif";